import { gql } from '@apollo/client';

export const ENQUEUE_JOB = gql`
    mutation enqueueJob($facilityJob: EnqueueFacilityJob!) {
        facility {
            job {
                enqueueJob(input: $facilityJob) {
                    jobId
                    correlationId
                }
            }
        }
    }
`;
